import { useEffect, useRef, useState } from "react";
import Footer from "../Footer/Footer";
import { matchPath, useLocation } from "react-router-dom";
import NavigationBar from "../Header/Navbar";
import TopBar from "../Header/TopBar";

const Layout = ({
  children,
  t,
  i18n,
  gmail,
  twitter,
  facebook,
  instagram,
  copyright,
  message,
  showMessage,
}) => {
  // react-router v7: useLocation() instead of a prop; matchPath() signature
  // swapped to (pattern, pathname) and now accepts only a single pattern at a
  // time (no array support), so iterate.
  const location = useLocation();

  const userProfilePatterns = [
    "/user/:username",
    "/user/properties/:pageNumber",
  ];
  const matchProfile = userProfilePatterns.some(
    (pattern) => matchPath({ path: pattern, end: true }, location.pathname)
  );

  const showFooterOn = [
    "/",
    "/contact",
    "/about",
    "/privacy",
    "/terms",
    "/users/login",
    "/users/signup",
    "/forgot-password",
    "/user/:username",
  ];

  // Intro
  const [addActive1, setAddActive1] = useState(false);
  const [addActive2, setAddActive2] = useState(false);
  const [addActiveLogo, setAddActiveLogo] = useState(false);
  const [addHeight, setAddHeight] = useState(true);

  const isMounted = useRef();

  useEffect(() => {
    const pkIntro = JSON.parse(window.localStorage.getItem("pkIntro"));
    isMounted.current = true;
    if (isMounted.current === true && (!pkIntro || pkIntro !== "pkIntro")) {
      // if (isMounted.current === true) {
      setAddHeight(false);
      setTimeout(() => {
        setTimeout(() => {
          setAddActive1(true);
        }, 400);

        setTimeout(() => {
          setAddActive2(true);
        }, 800);

        setTimeout(() => {
          setAddActiveLogo(true);
        }, 400);

        setTimeout(() => {
          setTimeout(() => {
            setAddActive1(false);
          }, 40);
          setTimeout(() => {
            setAddActive2(false);
          }, 80);

          setTimeout(() => {
            setAddActiveLogo(false);
          }, 40);
        }, 3500);

        setTimeout(() => {
          setAddHeight(true);
        }, 3800);
        window.localStorage.setItem("pkIntro", JSON.stringify("pkIntro"));
      });
    }
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <>
      <div className='h-100'>
        {/* Decorative splash; hidden from assistive tech so its logo isn't
            read as a second page heading. */}
        <div
          className='pkIntro'
          aria-hidden='true'
          style={{ top: addHeight && "-100vh", transition: addHeight && "1s" }}
        >
          <h1 className={`pkLogo ${addActiveLogo ? "active" : "fade"}`}>
            <span
              className={`pkLogoSpan ${addActive1 ? "active" : "fade"}`}
              style={{
                fontWeight: "400",
                backgroundColor: "var(--color-primary)",
                color: "#070707",
              }}
            >
              Pk
            </span>
            <span className={`pkLogoSpan ${addActive2 ? "active" : "fade"}`}>
              Plots
            </span>
          </h1>
        </div>
        <a href='#main' className='skip-link'>
          {t("a11y.skip_to_content")}
        </a>
        {showMessage === true ? <TopBar message={message} /> : ""}
        <NavigationBar t={t} i18n={i18n} />

        <main
          id='main'
          tabIndex={-1}
          // style={{ minHeight: "560px", height: "calc(100% - 4.25rem)" }}
          style={{ minHeight: "828px", height: "calc(100% - 4.25rem)" }}
          className='mainDiv'
        >
          {children}
        </main>
        {/* {location.pathname !== "/contact" && !match ? <Footer /> : null} */}
        {showFooterOn.includes(location.pathname) || matchProfile ? (
          <Footer
            t={t}
            i18n={i18n}
            gmail={gmail}
            twitter={twitter}
            facebook={facebook}
            instagram={instagram}
            copyright={copyright}
          />
        ) : null}
      </div>
    </>
  );
};

export default Layout;
